import React from 'react';
import { Link } from 'react-router-dom';

// Self-service email reset is not enabled yet, so we honestly route users to their
// gym instead of silently pretending to send an email. An admin can reset any of
// their gym's accounts from User Management.
export default function ForgotPassword() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Reset Your Password</h2>
        <p style={styles.message}>
          For your security, password resets are handled by your gym.
        </p>
        <p style={styles.message}>
          Please contact your gym's <strong>front desk or administrator</strong> — they
          can reset your password and give you a new temporary one, which you can change
          after logging in.
        </p>
        <Link to="/login" style={styles.link}>← Back to login</Link>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f3f4f6',
    padding: '1rem',
  },
  card: {
    background: '#fff',
    padding: '2rem',
    borderRadius: '12px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
    width: '100%',
    maxWidth: '400px',
  },
  title: { margin: '0 0 0.75rem', fontSize: '1.5rem', color: '#111827' },
  message: { color: '#374151', lineHeight: 1.6, marginBottom: '1rem' },
  link: { color: '#2563eb', textDecoration: 'none', fontSize: '0.9rem' },
};
